import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const EllipsisIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM14 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z", fill: "currentColor" })));
});
EllipsisIcon.displayName = 'EllipsisIcon';
export default EllipsisIcon;
